import 'bootstrap';

document.addEventListener('DOMContentLoaded', () => {

})